import React, { useEffect, useState } from "react";
import { Guest } from "../../AdminPanel";
import "../ModalStyles.css";
type Props = {
  guest: Guest | null;
  onSave: (updatedGuest: Guest) => void;
  onClose: () => void;
};

export const EditGuestModal = ({ guest, onSave, onClose }: Props) => {
  const [form, setForm] = useState<Guest | null>(null);

  useEffect(() => {
    if (guest) setForm({ ...guest });
  }, [guest]);

  const handleChange = (field: keyof Guest, value: any) => {
    if (!form) return;
    setForm({ ...form, [field]: value });
  };

  const handleSave = () => {
    if (form) onSave(form);
  };

  if (!form) return null;

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h3>Editar invitado</h3>

        <label>Nombre</label>
        <input
          value={form.name}
          onChange={(e) => handleChange("name", e.target.value)}
        />

        <label>Teléfono</label>
        <input
          value={form.phoneNumber}
          onChange={(e) => handleChange("phoneNumber", e.target.value)}
        />

        <label>Mesa</label>
        <input
          type="number"
          value={form.table ?? ""}
          onChange={(e) => handleChange("table", parseInt(e.target.value))}
        />

        <label>Pases</label>
        <input
          type="number"
          min={1}
          max={10}
          value={form.invited}
          onChange={(e) => handleChange("invited", parseInt(e.target.value))}
        />

        <div className="modal-buttons edit-button">
          <button onClick={handleSave}>Guardar</button>
          <button onClick={onClose}>Cancelar</button>
        </div>
      </div>
    </div>
  );
};
